// @ts-strict-ignore
import React, {FC, ReactNode} from 'react';

import {ToastType} from 'common/components/toast/types';
import {TrackingEvent, trackOnboardingEvent} from 'common/onboarding/immersive-onboarding/tracking';
import {addToast} from 'common/components/toast-area/toast-manager';
import {Permission} from 'common/report/constants';
import {useCurrentUser} from 'common/contexts/react/current-user-context';
import {useCurrentProject} from 'common/contexts/react/current-project-context';
import {useTranslation} from 'common/i18n/hooks';
import {useGlobalSidenavController} from 'common/contexts/react/global-sidenav-controller-context';

interface InviteTeammateButtonProps {
  children: ReactNode;
  className?: string;
  errorMessage?: string;
  setVisibility: (isVisible: boolean) => void;
}

export const InviteTeammateButton: FC<InviteTeammateButtonProps> = ({
  children,
  className,
  errorMessage,
  setVisibility,
}) => {
  const {t} = useTranslation();
  const currentUser = useCurrentUser().get().value;
  const currentProject = useCurrentProject().get().value;
  const globalSidenavController = useGlobalSidenavController();
  const {organizationId} = currentProject ?? {};
  const canInviteUsers = currentUser?.organizations?.[organizationId]?.permissions.includes(Permission.AddUser);

  const handleInvite = () => {
    if (canInviteUsers) {
      if (setVisibility) {
        setVisibility(false);
      }

      globalSidenavController.openInviteUserModal({
        closeCallback: () => setVisibility?.(true),
      });
    } else {
      addToast({
        type: ToastType.ERROR,
        message: errorMessage || t(`onboarding.welcome.no-invite-permission`),
      });
    }

    trackOnboardingEvent(TrackingEvent.InviteTeammate);
  };

  return (
    <div className={className} onClick={handleInvite}>
      {children}
    </div>
  );
};
